export default function GetBundleURL(name: string, rootID: string){
    return `/bundle/${name.replaceAll(' ', '-')}-${rootID}`
}